import {AxiosError, HttpStatusCode} from 'axios'
import {ROUTES} from '@/utils/constants/routesConstants'

// Mock function for unauthorized error handling (replace with actual logic)
const onUnauthorisedError = async () => {
  console.warn('User unauthorized. Redirecting...')
  // window.location.href = '/'
}

export const handleNetworkErrors = async error => {
  const {code, response, message} = error
  const status = response?.status

  if (code === AxiosError.ERR_CANCELED) {
    return Promise.reject(new Error(message || 'Request was canceled'))
  }

  if (status === HttpStatusCode.Forbidden) {
    window.location.href = ROUTES.ERROR_403
  } else if (status === HttpStatusCode.Unauthorized || code === AxiosError.ERR_NETWORK) {
    try {
      await onUnauthorisedError()
    } catch (signOutError) {
      console.error('onUnauthorisedError::ERROR', signOutError)
    }
  }
  // Collect error message from multiple potential sources
  const errArr = response?.data?.data?.flatMap(item => item.errors || [])
  // If the error array exists, join the messages, otherwise fall back to other fields
  const errorMessage = Array.isArray(errArr) && errArr.length > 0
    ? errArr.join(', ')
    : response?.data?.message || response?.data?.error_msg || message || 'An error occurred'

  // Create an Error instance so existing `.toThrow()` tests keep working, but
  // also attach the original Axios error information so callers can inspect
  // details such as `error.response`.
  const enrichedError = new Error(errorMessage || 'An unexpected error occurred, please try again later.')
  // Preserve useful properties for consumers
  enrichedError.code = code
  if (response) {
    enrichedError.response = response
  }

  return Promise.reject(enrichedError)
}

// Attach the interceptor to an Axios instance
export const attachErrorInterceptor = axiosInstance => {
  axiosInstance.interceptors.response.use(
    response => response, // Pass successful responses through
    handleNetworkErrors
  )
}
